import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MsalContext } from '@azure/msal-react';
import { Bell, Menu } from '../../../../assets/images';
import Logo from '../../../../assets/images/logo.svg';
import { AVATAR_MEDIUM } from '../../../utils/crops';

/** Utils */
import { navigateToFile } from '../../../utils/navigate';
import MenuList from './MenuList';
import {
  StyledAvatarPerson,
  StyledBoxLogo,
  StyledBoxPendingNotification,
  StyledElementsList,
  StyledHamburguer,
  StyledHeader,
  StyledIconPendingBell,
  StyledInterior,
  StyledLinkMobile,
  StyledListGeneral,
  StyledLogo,
  StyledNav,
  StyledPendingNotifications,
  StyledUser,
  StyledUserList
} from './style';
import UserMenu from './UserMenu';
import { logout } from '../../../utils/session';

class Header extends Component {
  constructor() {
    super();

    this.state = {
      activeMenuBurguer: false,
      activeMobile: null,
      menuUser: false,
      showUser: false,
      activeApps: false,
      activeNotifications: false,
      userProfileView: false,
      isMe: false
    };
  }

  componentDidMount() {
    this.upateAvatar();
  }

  componentDidUpdate(prevProps) {
    const { query } = this.props;
    const { query: prevQuery } = prevProps;

    if (query !== prevQuery) {
      this.onChangeSearch({ target: { value: query } });
    }

    if (prevProps.userProfile) {
      const { userId } = prevProps.userProfile;

      if (userId !== this.props.userProfile.userId) {
        this.upateAvatar(this.props.userProfile.userId);
      }
    }
  }

  hiddenScroll = () => {
    if (window.innerWidth < 1024) {
      document.body.style.overflow = 'hidden';
    }
  };

  activeScroll = () => {
    if (window.innerWidth < 1024) {
      document.body.style.overflow = 'unset';
    }
  };

  onToggleMenuBurguer = ev => {
    const { activeMenuBurguer } = this.state;
    ev.stopPropagation();
    this.setState(
      {
        activeMenuBurguer: !activeMenuBurguer,
        menuUser: false,
        showUser: false
      },
      () => {
        if (!activeMenuBurguer) {
          this.hiddenScroll();
        } else {
          this.activeScroll();
        }
      }
    );
  };

  onChangeSearch = ({ target }) => {
    const { setShowSearch, enterSearch } = this.props;
    enterSearch(target.value);

    setShowSearch(true);
  };

  onToggleSearch = () => {
    const { setShowSearch } = this.props;
    setShowSearch(true);
  };

  onFocusSearch = () => {
    const { setShowSearch } = this.props;
    setShowSearch(true);
  };

  onSelectedMenuMobile = id => {
    const { activeMobile } = this.state;
    if (id === activeMobile) {
      this.setState({ activeMobile: null });
    } else {
      this.setState({ activeMobile: id });
    }
  };

  onSetShowUser = () => {
    const { showUser } = this.state;
    this.setState({ showUser: !showUser });
    this.hiddenScroll();
  };

  onCloseShowUser = () => {
    this.setState({ showUser: false, menuUser: false });
    this.activeScroll();
  };

  onSetShowApps = e => {
    const { activeApps } = this.state;
    e.stopPropagation();
    this.setState({ activeApps: !activeApps });
  };

  onSetShowNotifications = e => {
    const { activeNotifications } = this.state;
    e.stopPropagation();
    this.setState({
      activeNotifications: !activeNotifications,
      showUser: false
    });
  };

  onHideNotifications = () => {
    this.setState({ activeNotifications: false });
  };

  onClickOutsideMenu = () => {
    this.setState({ menuUser: false, showUser: false });
  };

  onClickOutsideMenuList = url => {
    const { activeMenuBurguer } = this.state;
    if (activeMenuBurguer) {
      this.setState({ activeMenuBurguer: false });
      navigateToFile(url, '_self');
    }
  };

  onClickOutsideApps = () => {
    this.setState({ activeApps: false });
  };

  onLogout = () => logout({ instance: this.context.instance });

  onGoCMS = () => {
    navigateToFile('/cms');
  };

  onGoOffice = () => {
    navigateToFile('/office');
  };

  onClickOutsideMenuUser = ev => {
    ev.stopPropagation();
    this.setState({ menuUser: false });
    this.activeScroll();
  };

  showMenuUser = ev => {
    const { menuUser, showUser } = this.state;
    ev.stopPropagation();
    this.setState({
      menuUser: !menuUser,
      showUser: !showUser,
      activeApps: false,
      activeNotifications: false
    });
    this.hiddenScroll();
  };

  upateAvatar = idEmployee => {
    const { userId } = this.props.user;
    let pathUser = '';

    if (this.props.location) {
      pathUser = this.props.location.pathname;
    }

    const isProfile = pathUser.indexOf('mi_perfil') !== -1;

    if (isProfile) {
      const arrHref = pathUser.split('/');
      const idProfilePath = Number(arrHref[2]);
      let idProfile = 0;

      if (idEmployee) {
        idProfile = idEmployee;
      } else {
        idProfile = idProfilePath;
      }

      this.setState({
        userProfileView: isProfile,
        isMe: userId === idProfile
      });
    }
  };

  render() {
    const {
      headerMenu,
      showHeader,
      user,
      fixed,
      query,
      userId,
      timeStamp,
      className,
      notifications,
      history
    } = this.props;

    const {
      name,
      publicName,
      lastname,
      idDepartment,
      idArea,
      avatarPhoto,
      typology
    } = user;

    const {
      activeMenuBurguer,
      activeMobile,
      menuUser,
      showUser,
      activeApps,
      userProfileView,
      isMe
    } = this.state;

    const isRoleAdmin = _.includes(user.roles, 'ROLE_ADMIN_CMS');
    const isRoleAccess = _.includes(user.roles, 'ROLE_ACCESS_CMS');

    const numNotifications = _.find(
      notifications,
      notif => notif.typeAppNotification === 'ALL'
    ).count;
    const isNotificationPath =
      history.location?.pathname.indexOf('mis_notificaciones') !== -1;
    return (
      headerMenu && (
        <Fragment>
          <StyledHeader
            showHeader={showHeader}
            id="headerHome"
            fixed={fixed}
            className={className}
            userProfileView={userProfileView && !isMe}
          >
            <StyledNav className="Header-nav">
              <StyledInterior>
                <MenuList
                  onToggleMenuBurguer={this.onToggleMenuBurguer}
                  show={activeMenuBurguer}
                  onToggleMobileMenuCategory={this.onSelectedMenuMobile}
                  showMobileMenuCategory={activeMobile}
                  menu={headerMenu}
                  onClickOutside={
                    this.onClickOutsideMenuList || this.onToggleMenuBurguer
                  }
                  onChangeSearch={this.onChangeSearch}
                  value={query}
                  onFocus={this.onFocusSearch}
                  onToggleSearch={this.onToggleSearch}
                  name={publicName || name}
                  activeApps={activeApps}
                  onClickActiveApps={this.onClickOutsideApps}
                />
                <StyledHamburguer
                  id="menuHamburguer"
                  className="Header-hamburger"
                  svg={Menu}
                  onClick={this.onToggleMenuBurguer}
                  hover
                />
                <StyledLinkMobile to="/">
                  <StyledBoxLogo show>
                    <StyledLogo center svg={Logo} className="Header-logo" />
                  </StyledBoxLogo>
                </StyledLinkMobile>
                <StyledUserList userProfileView={userProfileView && !isMe}>
                  {!isNotificationPath && numNotifications > 0 && (
                    <StyledBoxPendingNotification
                      numNotifications={numNotifications}
                      to="/mis_notificaciones"
                    >
                      <StyledPendingNotifications>
                        {numNotifications}
                      </StyledPendingNotifications>
                      <StyledIconPendingBell svg={Bell} hover />
                    </StyledBoxPendingNotification>
                  )}
                  <StyledUser
                    onClick={this.showMenuUser}
                    onClickOutside={this.onClickOutsideMenuUser}
                    userProfileView={userProfileView && !isMe}
                  >
                    <StyledAvatarPerson
                      name={name}
                      lastname={lastname}
                      userId={String(userId)}
                      crop={AVATAR_MEDIUM}
                      avatarPhoto={avatarPhoto}
                      timeStamp={timeStamp}
                    />
                  </StyledUser>
                  <UserMenu
                    name={name}
                    lastname={lastname}
                    typology={typology}
                    show={showUser}
                    avatarPhoto={avatarPhoto}
                    menuUser={menuUser}
                    isRoleAdminOrAccess={isRoleAdmin || isRoleAccess}
                    onCloseShowUser={this.onCloseShowUser}
                    logout={this.onLogout}
                    onClickOutside={this.onClickOutsideMenu}
                    goCMS={this.onGoCMS}
                    showApps={e => {
                      this.setState({ activeApps: true });
                      this.onCloseShowUser();
                      e.stopPropagation();
                    }}
                    idEmployee={userId}
                    idDepartment={idDepartment}
                    idArea={idArea}
                    upateAvatar={this.upateAvatar}
                    timeStamp={timeStamp}
                  />
                </StyledUserList>

                <StyledListGeneral
                  active={activeApps}
                  className="Header-listGeneral"
                >
                  <StyledElementsList />
                  <StyledElementsList
                    userProfileView={userProfileView && !isMe}
                  >
                    <StyledUser
                      onClick={this.showMenuUser}
                      onClickOutside={this.onClickOutsideMenuUser}
                      userProfileView={userProfileView && !isMe}
                    >
                      <StyledAvatarPerson
                        name={name}
                        lastname={lastname}
                        userId={String(userId)}
                        crop={AVATAR_MEDIUM}
                        avatarPhoto={avatarPhoto}
                        timeStamp={timeStamp}
                      />
                    </StyledUser>
                  </StyledElementsList>
                </StyledListGeneral>
              </StyledInterior>
            </StyledNav>
          </StyledHeader>
        </Fragment>
      )
    );
  }
}

// Da acceso a la instancia de MSAL creada en MsalProvider, que es la que
// mantiene la caché de la sesión de Azure.
Header.contextType = MsalContext;

Header.propTypes = {
  showHeader: PropTypes.bool,
  fixed: PropTypes.bool,
  query: PropTypes.string
};

const mapStateToProps = state => ({
  userId: state.user.user.userId,
  typology: state.user.user.typology,
  timeStamp: state.user.timeStamp,
  query: state.header.searchQuery,
  userProfile: state.user.userProfile,
  notifications: state.notifications.notificationsList
});

export default withRouter(connect(mapStateToProps)(Header));
